// import './App.css';
import { useEffect, useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  TextField,
  Button,
} from "@material-ui/core";

import { FaEdit, FaRegTrashAlt, FaChevronLeft } from "react-icons/fa";

import { useHistory } from "react-router-dom";

function AssessmentSectionsTable({
  organizationId,
  assessmentSections,
  onEdit,
  onDelete,
  onElementSelected,
  selectedElementId,
}) {
  let history = useHistory();

  if (!assessmentSections) {
    return <span>wtf</span>;
  }

  return (
    <div className="sectionsTable">
      <Button
        variant="contained"
        color="primary"
        className="btn-main-limber mb-15 mr-15"
        onClick={() => {
          history.push(`/organization/${organizationId}`);
        }}
      >
        <FaChevronLeft className="icon-limber-white btnBack" size="1.5em" />
      </Button>
      <Button
        variant="contained"
        color="primary"
        className="btn-main-limber mb-15"
        onClick={() => {
          onEdit({});
        }}
      >
        Create Assessment Section
      </Button>

      <TableContainer
        component={Paper}
        style={{
          overflow: "auto",
          height: "95%",
        }}
      >
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell align="right">Name</TableCell>
              <TableCell align="right">Title</TableCell>
              {/* <TableCell align="right">Description</TableCell> */}
              <TableCell align="right">Edit</TableCell>
              <TableCell align="right">Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {assessmentSections.map((assessmentSection) => {
              return (
                <TableRow
                  key={assessmentSection.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  style={{
                    cursor: "pointer",
                    backgroundColor: selectedElementId === assessmentSection.id ? "#c1cddd" : "transparent",
                  }}
                  onClick={(evt) => {
                    if (!evt.isDefaultPrevented()) {
                      onElementSelected(assessmentSection);
                    }
                  }}
                >
                  <TableCell component="th" scope="row">
                    {assessmentSection.id}
                  </TableCell>
                  <TableCell component="th" scope="row">{assessmentSection.nickname}</TableCell>
                  <TableCell align="right">{assessmentSection.assessmentSectionTRs[0].section_title}</TableCell>
                  {/* <TableCell align="right">{assessmentSection.assessmentSectionTRs[0].section_description}</TableCell> */}
                  <TableCell align="right">
                    <FaEdit
                      className="icon-limber"
                      size="1.5em"
                      onClick={(evt) => {
                        evt.preventDefault();
                        onEdit(assessmentSection);
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <FaRegTrashAlt
                      className="icon-limber"
                      size="1.5em"
                      onClick={(evt) => {
                        evt.preventDefault();
                        onDelete(assessmentSection);
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default AssessmentSectionsTable;
